import React from 'react';
import { Container, Carousel } from 'react-bootstrap';

const CarouselSection = () => {
  // Common style to ensure all images have the same height and look professional
  const carouselImageStyle = {
    height: '600px', 
    objectFit: 'cover', // This prevents the image from stretching
    width: '100%', 
  };
  
  // Define your image paths here (ensure these are in your public/images folder)
  const imagePath1 = "/images/Digital mechine/Model_H1-PRO.png";
  const imagePath2 = "/images/Digital mechine/Model_Q1.jpg";
  const imagePath3 = "/images/Digital mechine/HF01.jpg";

  return (
    <Container fluid className="p-0">
        <Carousel interval={3000} pause="hover">
            
            {/* Slide 1 */}
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={imagePath1}
                    alt="Model H1-PRO"
                    style={carouselImageStyle} 
                />
                <Carousel.Caption>
                    <h3>Digital Printing Machine</h3>
                    <p>High-speed sublimation digital printing machine.</p>
                </Carousel.Caption>
            </Carousel.Item>

            {/* Slide 2 */}
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={imagePath2}
                    alt="Model Q1"
                    style={carouselImageStyle} 
                />
                <Carousel.Caption>
                    <h3>Textile Digital Printing</h3>
                    <p>Next-generation precision for textile manufacturing.</p>
                </Carousel.Caption>
            </Carousel.Item>

            {/* Slide 3 */}
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={imagePath3}
                    alt="HF01 Machine"
                    style={carouselImageStyle} 
                />
                <Carousel.Caption>
                    <h3>Industrial Solutions</h3>
                    <p>Advanced machinery for industrial scale production.</p>
                </Carousel.Caption>
            </Carousel.Item>

        </Carousel>
    </Container>
  );
};

export default CarouselSection;